export default {
  container: {
    marginTop: '.5rem',
  },
  radioGroup: {
    flexDirection: 'row',
  },
};
